import ResetListState from "components/ResetListState";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDrugs } from "./AllDrugs.action";

import CAT_CONSTANTS from "lookup/CatConstants";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import AllDrugList from "./AllDrugList";

const DEFAULT_PAGE_SIZE = 15;

const AllDrugs = () => {
  const dispatch = useDispatch();

  const { listState, totalElements } = useSelector((state) => {
    let ls = state.allDrugList?.listState;
    if (!ls) {
      ls = {
        page: 0,
        pageSize: DEFAULT_PAGE_SIZE,
        sorted: CAT_CONSTANTS.defaultMedDrugsSort,
        filtered: [],
        resized: [],
        expanded: {},
      };
    }

    return {
      listState: ls,
      totalElements:
        state.allDrugList.totalElements !== undefined
          ? state.allDrugList.totalElements
          : "Loading ...",
    };
  });

  // TODO: This should be somehow common in both medispanDrugList
  const updateData = useCallback(
    (state, preventUpdate) => {
      const nextState = {
        ...state,
        sorted: [...state.sorted],
        filtered: [...state.filtered],
      };

      if (!preventUpdate) {
        if (nextState.sorted !== CAT_CONSTANTS.defaultMedDrugsSort) {
          nextState.sorted.forEach((element) => {
            element.isDefault = false;
          });
        }

        const indexOfBgDefaultFilter = nextState.filtered.findIndex(
          (x) => x.id == "brandGenType" && x.value == "All"
        );
        if (indexOfBgDefaultFilter > -1) {
          nextState.filtered.splice(indexOfBgDefaultFilter, 1);
        }

        dispatch(
          getDrugs(
            nextState.pageSize,
            nextState.page,
            nextState.sorted,
            nextState.filtered,
            nextState.resized,
            nextState.expanded
          )
        );
      }
      // When preventUpdate is true, we previously only updated local state.
      // Redux already tracks listState via the FETCH_ALL_DRUG_LIST action.
    },
    [dispatch]
  );

  return (
    <Container className="list-container" fluid>
      <Row>
        <Col md={12}>
          <div className="codex-version-display-bar">
            <span style={{ float: "left" }}>
              {" "}
              Total Drugs: <strong>{totalElements}</strong>
            </span>
            <strong style={{ float: "center" }}>Drug List</strong>
            <ResetListState
              onReset={() =>
                updateData({
                  ...listState,
                  filtered: [],
                  sorted: CAT_CONSTANTS.defaultMedDrugsSort,
                })
              }
              resetterDisabled={
                listState.filtered.length === 0 &&
                listState.sorted === CAT_CONSTANTS.defaultMedDrugsSort
              }
            />
          </div>
        </Col>
      </Row>
      <AllDrugList />
    </Container>
  );
};

export default AllDrugs;
